export const PROFILEECOGESTURE_DOCTYPE =
  'com.grandlyon.ecolyo.profileecogesture'
